import React, { useState } from 'react'
import '../../styles/Dashboard.css'
import {DashboardSidebar,} from '../index'
import { Outlet } from 'react-router-dom'
import {useAuth} from '../../authentication/AuthContext'



const Dashboard = () => {
  const [selectedMenuItem, setSelectedMenuItem] = useState('sales');
  const {user} = useAuth()

  return (
    <div className="site-wrapper2">
      <div className='dashboard-container'>
        <div style={{zIndex:'100'}}>
          <DashboardSidebar onMenuItemClick={setSelectedMenuItem} />
        </div>
       
     <Outlet />
        
      </div>
      </div>
  )
}

export default Dashboard